import { Button, Stack, Typography } from '@mui/material'
import { useUpdateProfileMutation } from 'api/profileApi'
import { and, not, or, path } from 'ramda'
import { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { useAnalytics } from 'hooks'
import { Link } from 'react-router-dom'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

const ECRM = () => {
  const { sendEvent } = useAnalytics()
  const isOptedIn = useSelector(path(['user', 'email_opt_in']))

  const [hasInteracted, setHasInteracted] = useState(false)

  const [updateProfile, { isSuccess }] = useUpdateProfileMutation()

  const handleClick = () => {
    sendEvent('email_opt_in', {
      email_opt_in: true,
      opt_in_element: 'Article banner'
    })
    const body = new FormData()
    body.append('email_opt_in', 1)
    updateProfile(body)
  }

  useEffect(() => {
    if (isSuccess) setHasInteracted(true)
  }, [isSuccess])

  return (
    <Stack
      // eslint-disable-next-line sort-keys
      direction={{ xs: 'column', md: 'row' }}
      spacing={2}
      sx={{
        alignItems: 'center',
        backgroundColor: 'white',
        borderRadius: 1,
        boxShadow: ({ shadows }) => shadows[4],
        display: or(and(isOptedIn, not(hasInteracted))) ? 'none' : 'flex',
        px: 2,
        py: 1
      }}
    >
      {not(hasInteracted) ? (
        <>
          <Typography sx={{ color: 'secondary.dark' }} variant="body2">
            <FormattedMessage
              defaultMessage="Want well-being tips & more, straight to your inbox?"
              id="OyfYam"
            />
          </Typography>
          <Button onClick={handleClick}>
            <FormattedMessage defaultMessage="Subscribe" id="gczcC5" />
          </Button>
        </>
      ) : (
        <>
          <Typography sx={{ color: 'secondary.dark' }} variant="body2">
            <FormattedMessage
              defaultMessage="Wellness is coming your way!"
              id="WhHBVX"
            />
          </Typography>
          <Button
            endIcon={<ArrowForwardIcon />}
            LinkComponent={Link}
            sx={{
              fontWeight: 900,
              px: 0
            }}
            to="/profile?active=settings"
            variant="text"
          >
            <FormattedMessage
              defaultMessage="Update settings Any time"
              id="YHi7FW"
            />
          </Button>
        </>
      )}
    </Stack>
  )
}

export default ECRM
